
    export default {
      eager: true,
      root: "/src/routes",
      globPage:         import.meta.glob("/src/routes/**/*.page.(js|jsx|ts|tsx)", { eager: true }),
      globLayout:       import.meta.glob("/src/routes/**/layout.(js|jsx|ts|tsx)", { eager: true }),
      
    globPageServer:   {},
    globLayoutServer: {},
  
    };
  